/* Four-slide walkthrough. Shown once on first sign-in, and replayable any time from the
   "?" button in the sidebar. Slides and copy ported verbatim from artifact.html. */

import { $ } from "../util.js";
import { paintIcons } from "../icons.js";
import { prefs } from "../state.js";

const OB_SLIDES = [
  { icons: [["chat", "var(--magenta)", "var(--magenta-soft)"], ["search2", "var(--violet)", "var(--violet-soft)"], ["spark", "var(--teal)", "var(--teal-soft)"]],
    h: "Classify the AI-style searches in your GSC data",
    p: "People increasingly search the way they talk. This tool classifies every query - buckets, conversation stages, intent, user need and journey stage - so you can see that demand clearly. Signals are inferred from the query text itself." },
  { icons: [["folder", "var(--violet)", "var(--violet-soft)"], ["file", "var(--amber)", "var(--amber-soft)"], ["play", "var(--green)", "var(--green-soft)"]],
    h: "Work in projects",
    p: "Create a project per site, drop in your GSC Queries.csv (add the AI-feature Pages.csv if you have it), and hit Run analysis. Your projects and results stay saved between visits." },
  { icons: [["chart", "var(--violet)", "var(--violet-soft)"], ["route", "var(--teal)", "var(--teal-soft)"], ["table", "var(--sub)", "#F1F1F4"]],
    h: "Read the results",
    p: "Colored pills show buckets and conversation stages. Charts, Topics and the Search journey map show where demand concentrates. Click anything - every pill, bar, node and card filters the query table." },
  { icons: [["wrench", "var(--violet)", "var(--violet-soft)"], ["up", "var(--green)", "var(--green-soft)"], ["click", "var(--red)", "var(--red-soft)"]],
    h: "Act on it",
    p: "SEO actions turns the classification into work: Issue, Recommendation, Why it matters, Target, Priority and Expected impact, with evidence attached. Start with the High-priority cards." },
];

let obIdx = 0;

export function showOnboarding(idx) {
  obIdx = idx || 0;
  const sl = OB_SLIDES[obIdx];
  $("ob-root").innerHTML = '<div class="ob-scrim"><div class="ob">' +
    '<div class="oi">' + sl.icons.map(([ic, c, bg]) => '<i data-ic="' + ic + '" style="color:' + c + ";background:" + bg + '"></i>').join("") + "</div>" +
    "<h3>" + sl.h + "</h3><p>" + sl.p + "</p>" +
    '<div class="orow"><div class="odots">' + OB_SLIDES.map((_, i) => '<span class="' + (i === obIdx ? "on" : "") + '"></span>').join("") + "</div>" +
    '<div style="display:flex;gap:8px">' +
    '<button class="btn-x" id="ob-skip">Skip</button>' +
    '<button class="btn" id="ob-next" style="padding:7px 15px">' + (obIdx === OB_SLIDES.length - 1 ? "Get started" : "Next") + "</button></div></div></div></div>";
  paintIcons($("ob-root"));
  $("ob-skip").addEventListener("click", closeOnboarding);
  $("ob-next").addEventListener("click", () => {
    if (obIdx === OB_SLIDES.length - 1) closeOnboarding();
    else showOnboarding(obIdx + 1);
  });
}

export function closeOnboarding() {
  $("ob-root").innerHTML = "";
  prefs.onboarded = true;
}

export const SLIDE_COUNT = OB_SLIDES.length;
